import { render, staticRenderFns } from "./Anmerkung.vue?vue&type=template&id=782deee8&"
import script from "./Anmerkung.vue?vue&type=script&lang=js&"
export * from "./Anmerkung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports